import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'semantic-ui-react';
import { getItemTemplate, LinkMore } from '@package/components';

const DefaultTemplate = (data) => {
  const { items, isEditMode } = data;

  const align =
    items.filter(
      (i) => i['@type'] === 'Esperienza' || i['@type'] === 'SchedaTematica',
    ).length === items.length
      ? 'bottom'
      : 'top';

  return items.length > 0 ? (
    <>
      <Grid stackable columns={3} verticalAlign={align}>
        {items.map((item) => {
          let ItemTemplate = getItemTemplate(item);
          return (
            <Grid.Column key={item['@id']}>
              <ItemTemplate
                item={item}
                isEditMode={isEditMode}
                withTags={item['@type'] === 'Esperienza' ? false : true}
              />
            </Grid.Column>
          );
        })}
      </Grid>

      <LinkMore {...data} />
    </>
  ) : null;
};

DefaultTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default DefaultTemplate;
